import {
    RenderComponent,
    RenderFooter,
    RenderHeader,
    RenderLanguageField,
    RenderLanguageLink,
    RenderListPageWithCategory,
    RenderListPageWithChildren,
    RenderReportTechnicalUrlPage,
    RenderSearchField,
    RenderSearchLink,
    RenderSearchPage,
    RenderServiceCard,
} from "Framework";

export default {
    init: (model, element, menu) => {
        RenderComponent(model, element, menu);
    },
    initSearchLink: (element, model) => {
        RenderSearchLink(element, model);
    },
    initSearchField: (element, model) => {
        RenderSearchField(element, model);
    },

    initFooter: (footer, element, currentTheme) => {
        RenderFooter(footer, element, currentTheme);
    },
    initHeader: (header, element, currentTheme, divider) => {
        RenderHeader(header, element, currentTheme, divider);
    },

    initLanguageLink: (element, LanguageLinkText, model) => {
        RenderLanguageLink(element, LanguageLinkText, model);
    },
    initLanguageField: (element, languages, model) => {
        RenderLanguageField(element, languages, model);
    },

    initSearch: (element, model, searchQuery) => {
        RenderSearchPage(element, model, searchQuery);
    },
    initSearchWithCategories: (element, model, searchQuery) => {
        RenderListPageWithCategory(element, model, searchQuery);
    },
    initListPageWithChildren: (element, model) => {
        model.currentPageId = model.Id;
        RenderListPageWithChildren(element, model);
    },
    initReportTechnicalUrlPage: (element, model) => {
        RenderReportTechnicalUrlPage(element, model);
    },
    initServiceCard: (element, model) => {
        RenderServiceCard(element, model);
    },
};
